import * as React from 'react';
import { cn } from '../../../utils';
import { Tabular } from '../../Icon/icon';
import { Arrow, Settings } from 'rcd-cpp-ui/ui/icon';
import { NavGroupHeader } from '../NavGroup/navGroup';
import { useActions } from '../navActions';
import { NavGroups } from '../../../enums/NavGroups';
import { useSelector } from '../../../utils/useSelector';
import { NodeType } from '../../../enums/NodeType';
import URLManager from '../../../utils/urlManager';
import { ContextMenuLink } from '../../ContextMenuLink/contextMenuLink';

const Options = [
  {
    name: 'Workspace Setting',
    path: '/admin/setting',
    Icon: Settings
  },
  { name: 'Permission', path: '/admin/permission', Icon: Tabular },
  {
    name: 'Publish Staged Tags',
    path: '/admin/staged/publish',
    Icon: Tabular
  }
];

const isSelected = (path: string) => window.location.pathname.endsWith(path);

export const NavAdmin = props => {
  const { disabled } = props;
  const selectedWorkspace = useSelector(s => s.planning?.selectedWorkspace);
  const [isExpanded, setExpanded] = React.useState<boolean>(null);
  const { navigate } = useActions();
  const pathname = window.location.pathname;
  React.useEffect(() => {
    if (isExpanded === null && pathname.includes('/admin/')) {
      setExpanded(true);
    }
  }, [pathname]);
  if (!selectedWorkspace) return;
  const isAdminWorkspace = selectedWorkspace?.labels?.includes(
    NodeType.AdminWorkspace
  );
  const options = React.useMemo(
    () =>
      Options.filter(o => {
        if (disabled && o.path == '/admin/setting') return false;
        if (!isAdminWorkspace && o.path == '/admin/staged/publish')
          return false;
        return true;
      }),
    [disabled, isAdminWorkspace]
  );
  return (
    <div className={cn({ 'nav-group-collasped': !isExpanded }, 'nav-group')}>
      <NavGroupHeader
        name={NavGroups.Administration}
        isExpanded={!!isExpanded}
        toggleIsExpanded={() => {
          setExpanded(!isExpanded);
        }}
      />
      <div className="cp-nav-collapsible">
        {options.map(({ name, path, Icon }) => {
          const selected = isSelected(path);
          const href = URLManager.generateUrl(selectedWorkspace, { path });
          return (
            <div
              key={name}
              className={cn(
                {
                  'selected-ngi': selected
                },
                'nav-group-item'
              )}
            >
              <ContextMenuLink
                href={href}
                onNavigate={() => navigate(selectedWorkspace, { path })}
              >
                <span>
                  <Icon />
                </span>
                <span className="view-name">{name}</span>
                <span>
                  {selected && <Arrow direction="right" type="solid" />}
                </span>
              </ContextMenuLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};
